<template>
  <kinesis-container class="header">
    <kinesis-element
      class="circle circle-blue"
      :strength="40"
    ></kinesis-element>
    <kinesis-element
      class="circle circle-purple"
      :strength="-10"
    ></kinesis-element>
    <kinesis-element
      class="circle circle-yellow"
      :strength="50"
    ></kinesis-element>
    <kinesis-element
      class="circle circle-green"
      :strength="-10"
    ></kinesis-element>
    <kinesis-element
      class="circle circle-orange"
      :strength="-30"
    ></kinesis-element>
    <kinesis-element class="circle circle-red" :strength="30">
    </kinesis-element>
    <Title />

    <kinesis-element
      type="depth_inv"
      class="catcher"
      transformOrigin="center 200px"
      :strength="-5"
      >Easy to use</kinesis-element
    >
    <!-- <kinesis-element
      type="depth_inv"
      :strength="10"
      transformOrigin="center 200px"
      >& Fun to use</kinesis-element
    > -->
    <kinesis-element
      type="depth_inv"
      class="catcher"
      :strength="10"
      transformOrigin="center 200px"
      >Vue.js components</kinesis-element
    >
    <kinesis-element
      type="depth_inv"
      class="catcher"
      :strength="15"
      transformOrigin="center 200px"
      >for interactive animations</kinesis-element
    >
    <kinesis-element
      type="depth_inv"
      class="catcher github"
      :strength="20"
      transformOrigin="center 200px"
    >
      <a href="https://github.com/Aminerman/vue-kinesis" target="_blank"
        ><img src="../assets/github.svg" height="30" alt=""
      /></a>
    </kinesis-element>
  </kinesis-container>
</template>

<script>
// import KinesisContainer from "./kinesis-container";
import KinesisElement from "./kinesis-element";
import Title from "./Title.vue";
export default {
  components: {
    // KinesisContainer,
    KinesisElement,
    Title
  }
};
</script>

<style lang="scss" scoped>
$circle-size: 4vw;

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  position: relative;
}

.circle {
  border-radius: 100%;
  position: absolute;

  &.circle-blue {
    background-color: $color-blue;
    width: $circle-size * 8;
    height: $circle-size * 8;
    top: 5%;
    right: -$circle-size * 4;
  }

  &.circle-purple {
    border: 25px solid $color-purple;
    width: $circle-size * 4;
    height: $circle-size * 4;
    left: 50%;
  }

  &.circle-yellow {
    background-color: $color-yellow;
    width: $circle-size * 2;
    height: $circle-size * 2;
    left: 30%;
    top: 25%;
  }

  &.circle-green {
    background-color: $color-green;
    width: $circle-size * 2.5;
    height: $circle-size * 2.5;
    right: 20%;
    top: 90%;
  }

  &.circle-orange {
    border: 25px solid $color-orange;
    width: $circle-size * 2;
    height: $circle-size * 2;
    left: 20%;
    top: 60%;
  }

  &.circle-red {
    background-color: $color-red;
    width: $circle-size * 3;
    height: $circle-size * 3;
    left: -$circle-size * 1.2;
    top: 25%;
  }
}

.catcher {
  position: relative;
  z-index: 5;
}

.github {
  margin-top: 20px;
}
</style>
